/**
 * Guided agent templates — prefill persona/greeting/useCase for quick setup.
 * Advanced STT/LLM/TTS use platform defaults until user opens full editor.
 */

export const AGENT_TEMPLATES = [
  {
    id: 'customer-support',
    name: 'Customer support',
    icon: '🎧',
    useCase: 'customer-service',
    greeting: 'Hello! Thanks for calling. How can I help you today?',
    persona:
      'You are a friendly customer support agent. Listen carefully, confirm understanding, and offer clear next steps. Stay calm and professional.',
  },
  {
    id: 'appointment-booking',
    name: 'Appointment booking',
    icon: '📅',
    useCase: 'healthcare',
    greeting: 'Hi! I can help you schedule an appointment. What day works best for you?',
    persona:
      'You are an appointment scheduling assistant. Collect name, preferred date/time, and reason for visit. Confirm details before ending the call.',
  },
  {
    id: 'service-crm',
    name: 'Service CRM',
    icon: '🔧',
    useCase: 'sales',
    greeting: 'Hello! I can help with your service request or follow-up. What do you need today?',
    persona:
      'You are a service desk agent connected to CRM workflows. Capture issue summary, account or ticket reference if provided, and promised follow-up actions.',
  },
  {
    id: 'lead-qualification',
    name: 'Lead qualification',
    icon: '📞',
    useCase: 'marketing',
    greeting: 'Hi! Thanks for your interest. I have a few quick questions to see how we can help.',
    persona:
      'You are a sales development agent. Qualify leads with budget, timeline, and need. Be concise and respectful of the caller\'s time.',
  },
];

export const BLANK_TEMPLATE = {
  id: 'blank',
  name: 'Start from scratch',
  icon: '✨',
  useCase: 'marketing',
  greeting: 'Hello! How can I assist you today?',
  persona: '',
};

export function getTemplateById(id) {
  if (id === 'blank') return BLANK_TEMPLATE;
  return AGENT_TEMPLATES.find((t) => t.id === id) || BLANK_TEMPLATE;
}
